import { SweepUpdateStage } from '@inplay/models';
import { FC, useEffect } from 'react';
import { SweepEditHistoryProps } from './sweepReport.type';
import { useSweepHistory } from '../../hooks/useSweepData';
import Loading from '../../assets/loading/loading';
import {
  renderSweepCompletedStage,
  renderSweepUpdatedStage,
} from './sweepHelper';
import { SweepStage } from './sweeps.type';

const EditHistoryList: FC<SweepEditHistoryProps> = (props) => {
  const { sweepHistory, sweepHistoryLoading, fetchSweepHistory } =
    useSweepHistory();

  useEffect(() => {
    if (props.selectedSweepSummary?._id) {
      fetchSweepHistory(props.selectedSweepSummary?._id);
    }
  }, [props.selectedSweepSummary?._id]);

  const sortByUpdatedAtSweepEditHistory = (
    sweepEditHistory: SweepStage[],
  ): SweepStage[] => {
    return [...sweepEditHistory].sort(
      (previousStage: SweepStage, nextStage: SweepStage) =>
        new Date(previousStage.updatedAt).getTime() -
        new Date(nextStage.updatedAt).getTime(),
    ) as SweepStage[];
  };

  if (sweepHistoryLoading) {
    return (
      <div className="flex items-center justify-center h-[620px]">
        <Loading />
      </div>
    );
  }

  return (
    <div>
      {renderSweepCompletedStage(sweepHistory[SweepUpdateStage.GENERATED])}

      {renderSweepUpdatedStage(
        sortByUpdatedAtSweepEditHistory(
          sweepHistory[SweepUpdateStage.EDITED] ?? [],
        ),
      )}

      {renderSweepUpdatedStage(
        sortByUpdatedAtSweepEditHistory(
          sweepHistory[SweepUpdateStage.PLAYER_UPDATE] ?? [],
        ),
      )}
      {renderSweepUpdatedStage(
        sortByUpdatedAtSweepEditHistory(
          sweepHistory[SweepUpdateStage.COMPLETED] ?? [],
        ),
      )}
      {renderSweepUpdatedStage(
        sortByUpdatedAtSweepEditHistory(
          sweepHistory[SweepUpdateStage.REVIEWED] ?? [],
        ),
      )}
    </div>
  );
};

export default EditHistoryList;
